import { createUAParser } from './lib/uaparser';
const uaParser = createUAParser();
const unspec = 'unspecified';
/**
 * Returns the browser name, ready to be plugged into the 'Browser Name' property.
 *
 * @returns {string} the browser name string
 */
export function getBrowserName() {
    const name = uaParser.getBrowser().name;
    return name !== null && name !== void 0 ? name : unspec;
}
/**
 * Returns the browser version string, ready to be plugged into the 'Browser Version' property.
 *
 * @returns a browser version string, or null if not provided by the UA
 */
export function getBrowserVersion() {
    const version = uaParser.getBrowser().version;
    return version !== null && version !== void 0 ? version : null;
}
/**
 * Returns a device type string to be plugged into the 'Device Type' property.
 * NOTE: For regular PC browsers, ua-parser-js returns an undefined
 * deviceType. This is replaced with 'desktop' (used to be 'unspecified').
 *
 * @returns the device type string
 */
export function getDeviceType() {
    const deviceType = uaParser.getDevice().type;
    return deviceType !== null && deviceType !== void 0 ? deviceType : 'desktop';
}
/**
 * Returns a device vendor string to be plugged into the 'Device Vendor' property.
 * May return null if the vendor isn't specified in the user agent.
 *
 * @returns a device vendor string or null
 */
export function getDeviceVendor() {
    const deviceVendor = uaParser.getDevice().vendor;
    return deviceVendor !== null && deviceVendor !== void 0 ? deviceVendor : null;
}
/**
 * Return a device model string to be plugged into the 'Device Model' property.
 * May return null if the vendor isn't specified in the user agent.
 *
 * @returns a device model string or null
 */
export function getDeviceModel() {
    const deviceModel = uaParser.getDevice().model;
    return deviceModel !== null && deviceModel !== void 0 ? deviceModel : null;
}
/**
 * Returns the OS name to be plugged into the 'OS Name' property.
 *
 * @returns the OS name string
 */
export function getOSName() {
    const name = uaParser.getOS().name;
    return name !== null && name !== void 0 ? name : unspec;
}
/**
 * Returns the OS version string, to be pluggined into the 'OS Version' property.
 *
 * @returns the OS version string
 */
export function getOSVersion() {
    const version = uaParser.getOS().version;
    return version !== null && version !== void 0 ? version : unspec;
}
/**
 * Returns the 'short time zone name' e.g. "CEST".
 *
 * @returns the timezone name
 */
export function getTimeZoneName() {
    let tz;
    try {
        tz = new Date().toLocaleDateString('en-US', { timeZoneName: 'short' }).split(' ')[1];
    }
    catch (err) {
        tz = unspec;
    }
    return tz;
}
/**
 * Returns the locale timezone offset from UTC in hours as integer.
 *
 * @returns the time zone offset in the form '+2'
 */
export function getTimeZone() {
    const tzo = -new Date().getTimezoneOffset();
    const offset = Math.round(tzo / 60);
    return offset;
}
/**
 * Returns the locale string obtained from Intl or 'unspecified'.
 *
 * @returns the locale string (e.g. 'en-GB')
 */
export function getSystemLocale() {
    let locale;
    try {
        locale = Intl.DateTimeFormat().resolvedOptions().locale;
    }
    catch (err) {
        locale = unspec;
    }
    return locale;
}
//# sourceMappingURL=systeminfo.js.map